
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { ParcelValidationErrors } from "@/hooks/useParcelValidation";
import ErrorMessage from "./ErrorMessage";

interface ParcelInsuranceFieldProps {
  insuranceEnabled: boolean;
  value: string;
  index: number;
  onInsuranceToggle: (enabled: boolean) => void;
  onValueChange: (value: string) => void;
  errors?: ParcelValidationErrors;
}

const ParcelInsuranceField: React.FC<ParcelInsuranceFieldProps> = ({
  insuranceEnabled,
  value,
  index,
  onInsuranceToggle,
  onValueChange,
  errors = {}
}) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-4">
        <div className="flex items-center space-x-2">
          <Switch
            id={`insurance-${index}`}
            checked={insuranceEnabled}
            onCheckedChange={onInsuranceToggle}
          />
          <Label htmlFor={`insurance-${index}`}>Add insurance coverage</Label>
        </div>
        
        {/* Value input - shown inline when insurance is enabled */}
        {insuranceEnabled && (
          <div className="flex-1 max-w-md">
            <Input
              type="number"
              value={value}
              onChange={(e) => onValueChange(e.target.value)}
              placeholder="Enter parcel value"
              className={errors.value ? "validation-error-border" : ""}
            />
            <ErrorMessage error={errors.value} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ParcelInsuranceField;
